export function SentryFallback() {
  return (
    <div style={{ padding: "2rem", fontFamily: "system-ui, sans-serif" }}>
      <h1>Erreur inattendue</h1>
      <p>L’interface d’administration a rencontré un problème. Vous pouvez recharger la page.</p>
      <button type="button" onClick={() => window.location.reload()}>
        Recharger
      </button>
    </div>
  );
}
